import { GeoEntity, GeoItem } from '../@types/geoEntity'
import { SprengnetterLocation } from './valuationClient'
import { sendErrorLog } from './logClient'
import { ErrorLogSource } from '../@types/errorLog'

const gacApiFetch = async (query: string, types = 'postcode'): Promise<Array<GeoItem>> => {
  return fetch(`${process.env.GEO_API_URL}/locations.json?i=${query}&t=${types}`)
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw new Error(`${response.status}`)
    })
    .catch((error) => {
      const errorMessage = `Error while getting GAC locations, query: ${query}, types:${types}, message: ${error.message}`
      sendErrorLog({
        message: errorMessage,
        source: ErrorLogSource.GAC_LOCATION,
      })
      throw new Error(errorMessage)
    })
}
export const gacItemToLocation = (geoItem: GeoItem): SprengnetterLocation | null => {
  const splitted = geoItem.entity && geoItem.entity.label ? geoItem.entity.label.split(',') : undefined

  if (splitted && splitted.length === 2) {
    const street = splitted[0].trim()
    const postcodeCityDistrict = splitted[1].trim().split('-')

    const cityAndPostcode = postcodeCityDistrict[0]

    const postcode = cityAndPostcode.substr(0, cityAndPostcode.indexOf(' ')).trim()
    const city = cityAndPostcode.substr(cityAndPostcode.indexOf(' ')).trim()

    return { city: city, street: street, postcode: postcode }
  } else {
    return null
  }
}

const getSprengnetterLocationByPostcode = async (postcode: string): Promise<SprengnetterLocation> =>
  gacApiFetch(postcode, 'street').then((geoItems) => {
    const location = gacItemToLocation(geoItems[0])
    if (!location) {
      throw new Error("Can't get valid street")
    }
    return location
  })

const getGeoEntity = async (id: string): Promise<GeoEntity> => {
  return fetch(`${process.env.GEO_API_URL}/entities/${id}?g=WGS84`)
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw new Error(`${response.status}`)
    })
    .catch((error) => {
      const errorMessage = `Error while getting GAC entity, entity id: ${id} , message: ${error.message}`
      sendErrorLog({
        message: errorMessage,
        source: ErrorLogSource.GAC_ENTITY,
      })
      throw new Error(errorMessage)
    })
}

export { gacApiFetch, getGeoEntity, getSprengnetterLocationByPostcode }
